import { Directive, computed, input } from '@angular/core';

/**
 * Adds support for readonly to radio groups
 *
 * @example
 * <select appReadonlySelect>
 * 		<option>...</option>
 * </select>
 */
@Directive({
  selector: 'select[appReadonlySelect]',
  host: {
    '[attr.aria-disabled]': 'ariaDisabled()',
    '[attr.aria-labelledby]': 'ariaLabelledBy()',
    '(click)': 'onClick($event)',
    '(keydown)': 'onKeydown($event)',
  },
})
export class ReadonlySelectDirective {
  appReadonlySelect = input(false);

  ariaDisabled = computed(() => (this.appReadonlySelect() ? 'true' : 'false'));
  ariaLabelledBy = computed(() => (this.appReadonlySelect() ? 'readonly-help' : null));

  onClick(event: MouseEvent) {
    if (this.appReadonlySelect()) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  onKeydown(event: KeyboardEvent) {
    if (this.appReadonlySelect() && event.key === ' ') {
      event.preventDefault();
      event.stopPropagation();
    }
  }
}
